/**
 * Constants for localStorage and sessionStorage keys used throughout the application.
 * Use these constants instead of magic strings to ensure consistency and ease of refactoring.
 */
export const STORAGE_KEYS = {
  // Used in both localStorage and sessionStorage
  ARP_TOKEN: 'ARP_Token',

  // sessionStorage only
  OFF_PLATFORM_SECRET: 'OffPlatform_SecretKey'
} as const;
